import Container from "../Container";
import PrimaryButton from "../PrimaryButton";

const Newsletter = () => {
  return (
    <section className="bg-[#0B2367] py-12">
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          <div className="text-white text-2xl">
            Want to become the first one to know our updates? Sign up for
            newsletter!
          </div>
          <div className="flex">
            <input
              type="text"
              className="px-3 rounded-md rounded-r-none outline-none"
              placeholder="Your email address"
            />
            <PrimaryButton className="rounded-l-none">
              Subscribe Now
            </PrimaryButton>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Newsletter;
